"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("../mixins");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Paragraph = _styledComponents["default"].p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-b3zl0q-0"
})(["text-align:left;", ";", ";margin:", ";", ";"], _mixins.textAlignMixin, _mixins.colorMixin, function (props) {
  return "0 0 ".concat(props.theme.spaces.base);
}, _mixins.marginMixin);
Paragraph.displayName = "Paragraph";
var _default = Paragraph;
exports["default"] = _default;